module.exports = __webpack_public_path__ + "img/img07.b60094d5.svg";